module.exports = __webpack_public_path__ + "static/media/camera.1800c5f5.png";